const LANGUAGES = [
    {
        name: 'english',
        value: 'EN',
        image: '../../assets/images/flags/us.jpg'
    }, 
    {
        name: 'spanish',
        value: 'ES',
        image: '../../assets/images/flags/spain.jpg'
    }
]

module.exports = {
    LANGUAGES
}